module.exports = __webpack_public_path__ + "assets/d1a8d3b5a00eba7f1888f4ca3c5c9304.mp3";